/**
 * Every string a fan reads in the web delete-account flow.
 *
 * The body enumerates what deletion really destroys per owner answer Q183 and
 * ISSUE-118's real handler sequence. Picks, results, and messages stay in
 * other people's pools on purpose. These strings are pinned by the colocated
 * test so a reword is a deliberate act.
 */

export const DELETE_ACCOUNT_TITLE = "Delete your account?";

export const DELETE_ACCOUNT_BODY = `This can't be undone. Here's what happens:

• Your profile is deleted: your name, photo, username, and settings.
• Your email, Apple, and Google sign-ins are freed. Any of them can start a new account.
• Pools you run pass to another member. A pool with nobody else in it is closed.
• Your past picks, results, and messages stay in other people's pools. Your name on them becomes "Deleted account".`;

export const DELETE_ACCOUNT_CONFIRM_LABEL = "Delete account";

export const DELETE_ACCOUNT_LAST_SUPER_ADMIN_MESSAGE =
  "You're the last staff member with full access. Give someone else full access first, then delete this account.";

export const DELETE_ACCOUNT_DONE_MESSAGE = "Your account has been deleted.";

export const DANGER_ZONE_TITLE = "Danger zone";

export const DANGER_ZONE_LEAD =
  "Deleting your account is permanent. Read what goes before you start.";

export const LAST_SUPER_ADMIN_CODE = "LAST_SUPER_ADMIN";

export function buildDeleteRequestId(): string {
  return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
}
